import {Request} from './Request';

export class CancelReservationRequest implements Request {
    private reservationId: number;
    chargePointSelectList: string[];

    constructor(chargePointSelectList: string[], reservationId?: number) {
        this.reservationId = reservationId;
        this.chargePointSelectList = chargePointSelectList;
    }
    public toString = (): string => {
        return `CancelReservationRequest (reservationId: ${this.reservationId})`;
    }

    get reservation_id(): number {
        return this.reservationId;
    }

    set reservation_id(value: number) {
        this.reservationId = value;
    }
}
